// extracted by mini-css-extract-plugin
export var reviews = "style-module--reviews--83d73";
export var reviews__title = "style-module--reviews__title--db1fe";